import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IUser} from '../../core/interfaces/user';
import {FirebaseService} from '../../services/firebase/firebase.service';

@Component({
  selector: 'kt-visibility-buttons-tutorial-dialog',
  templateUrl: './visibility-buttons-tutorial-dialog.component.html',
  styleUrls: ['./visibility-buttons-tutorial-dialog.component.scss']
})
export class VisibilityButtonsTutorialDialogComponent {

  dontShowAgain = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: IUser, hideShowAgain?: boolean },
    public dialogRef: MatDialogRef<VisibilityButtonsTutorialDialogComponent>,
    private firebase: FirebaseService,
  ) { }

  close() {
    const updatedUser = JSON.parse(JSON.stringify(this.data.user));
    updatedUser.showVisibilityTutorial = !this.dontShowAgain;
    this.firebase.updateUser(updatedUser.uid, updatedUser);
    this.dialogRef.close();
  }
}
